import { Component } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { Router } from 'express-serve-static-core';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html'
})
export class AppComponent {
  public title: string = 'front-routing-balancer';

  
}
